'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = require('video.js');

var _video2 = _interopRequireDefault(_video);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _DebugManager = require('../../utils/DebugManager');

var _DebugManager2 = _interopRequireDefault(_DebugManager);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Plugin = _video2.default.getPlugin('plugin');
var dmInstance = _DebugManager2.default.dmInstance;

/**
 * Base class for processing component events. Adds text tracks
 * and handles cue change events from them.
 * Any class wishing to implement their own cue processing
 * will likely override parseCueData
 * 
 * @param {Player} player
 *        A Video.js player instance.
 * 
 * @param {Object} options 
 *        The options to configure the plugin.
 * 
 *        Options object should include:
 * 
 *        @param {Function} dataHandler
 *        Data handler when the plugin fires `inBandEvent`.
 * 
 *        @param {Function} trackHandler
 *        Event handler to process a newly added track.
 * 
 */

var ComponentEventProcessorBase = function (_Plugin) {
  _inherits(ComponentEventProcessorBase, _Plugin);

  function ComponentEventProcessorBase(player, options) {
    _classCallCheck(this, ComponentEventProcessorBase);

    var _this = _possibleConstructorReturn(this, (ComponentEventProcessorBase.__proto__ || Object.getPrototypeOf(ComponentEventProcessorBase)).call(this, player, options));

    _this.handleCueChange = function (track) {
      // if track.kind is not metadata, we need to abort
      if (!track) return false;
      if (track.kind !== 'metadata') return false;

      // get the current time of the video player and process all cue events prior to it
      // making sure we don't double process an event
      var playerTime = _this.player.currentTime() + _this.startTimeOffset;

      // textTrack.cues: A TextTrackCueList which contains all of the track's cues.
      // We originally used activeCues, but we found that can only safely handle 2 cue events
      // per second until it starts dropping events

      var cues = track.cues;

      var cuesLength = cues.length;

      //in some cases the player fires a "seeked" event when loading content, 
      //which brings us here before the cues have been set up
      if (cuesLength === 0) return false;

      // get the counter for the last processed startTime
      var processCueIndex = 0;
      for (var i = 0; i < cuesLength; i += 1) {
        if (_this.lastProcessedStartTime === cues[i].startTime) {
          processCueIndex = i + 1;
          break;
        }
      }

      //don't process index if it's outside the bounds of cues array
      if (processCueIndex >= cuesLength) return false;

      var parsedCueForDebug = _this.parseCueData(cues[processCueIndex]);
      dmInstance.logMessage([_DebugManager2.default.debugLevel.B, _DebugManager2.default.debugLevel.V], '[ComponentEventProcessorBase] cue event received - cueTime: ', cues[processCueIndex].startTime, ' playerTime: ', playerTime, ' data: ', parsedCueForDebug.data);

      // process the cues that have not yet been processed and have a startTime less than the current
      // video time
      var isDirty = false;
      for (; processCueIndex < cuesLength; processCueIndex += 1) {
        // This check against the current video player time is needed due to cue events being
        // occaisionally received before they should be run.
        // (We will see these events that have a timestamp in the future, i.e. greater than the
        // current time of the video player)
        // Usually, this happens after some time has passed with no events. When this happens, the
        // activeCues length is also zero.
        // I have no idea why this happens.
        if (cues[processCueIndex].startTime <= playerTime) {
          isDirty = true;
          var parsedCueData = _this.parseCueData(cues[processCueIndex]);

          dmInstance.logMessage([_DebugManager2.default.debugLevel.B, _DebugManager2.default.debugLevel.V], '[ComponentEventProcessorBase] cue event parsed and dispatched: ', parsedCueData.data, ' cueTime: ', cues[processCueIndex].startTime);

          // if we parsed the cue data successfully, trigger the inBand event processor
          if (!(0, _isEmpty2.default)(parsedCueData)) {
            _this.trigger(_constants.VideoEvents.COMPONENT_EVENT, parsedCueData);
          }
          _this.lastProcessedStartTime = cues[processCueIndex].startTime;
        } else break;
      }
      return isDirty;
    };

    _this.dataHandler = options.dataHandler;
    _this.trackHandler = options.trackHandler;

    _this.init(options);
    _this.addEventListeners();
    return _this;
  }

  _createClass(ComponentEventProcessorBase, [{
    key: 'init',
    value: function init(opts) {
      var _this2 = this;

      this.startTimeOffset = opts.start || 0;
      var textTracks = this.player.textTracks();
      if (textTracks) {
        textTracks.on('addtrack', function (event) {
          _this2.trackHandler(event.track, _this2.handleCueChange);
        });

        // for iOS we need to listen to the change event on the text track
        // in order to set up the cuechange listener WN-3315
        if (_video2.default.browser.IS_IOS && _video2.default.browser.IS_SAFARI) {
          textTracks.addEventListener('change', function (event) {
            for (var i = 0, L = event.target.length; i < L; i++) {
              _this2.trackHandler(event.target[i], _this2.handleCueChange);
            }
          });
        }
      } else {
        console.log('DEBUG: no textTracks found');
        return false;
      }
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {}
  }, {
    key: 'parseCueData',


    /**
     * Generates a JSON object based on the type of data received from
     * the in band event and triggers an "inBandEvent" with the data
     *
     * @param {String|Uint8Array} cueText the data received from the in band event
     * @return {Boolean} whether or not the data was parseable as JSON
     */
    value: function parseCueData(cue) {
      if ((0, _isUndefined2.default)(cue)) return;
      var returnData = void 0;
      var data = void 0;
      // Safari: data resides in cue.value.data as a human-readable string
      // For Chrome and Firefox, data is in cue.text in various formats handled below.
      var cueText = cue.text ? cue.text : cue.value.data;
      if (cueText instanceof Uint8Array) {
        // Uint8Array, join it first so it becomes a comma separated string
        data = this.convertCueAsciiToText(cueText.join());
      } else if (/^(\d+,)*\d+$/.test(cueText)) {
        // comma separated numbers, so parse as is
        data = this.convertCueAsciiToText(cueText);
      } else if (typeof cueText === 'string') {
        // assume it's JSON
        data = cueText;
      }

      try {
        returnData = JSON.parse(data);
      } catch (e) {
        // WARNING: we always need to catch exceptions here so the app can recover from a bad component event!
        console.warn('Unable to parse in-band event data because of an unknown format. Received data: ' + cueText);
      }
      return returnData;
    }

    /**
     * Converts a comma-separated string of numbers (character codes)
     * to a readable string of corresponding characters
     *
     * Note: the first and last characters are "end of text"/null characters,
     * so we must strip them in order to parse the converted stringified JSON object
     * So, this is the purpose of the .slice(1, -1) code
     *
     * @param {String} text the string of numbers to convert
     * @return {String}
     */

  }, {
    key: 'convertCueAsciiToText',
    value: function convertCueAsciiToText(text) {
      return text.split(',').slice(1, -1).map(function (int) {
        return String.fromCharCode(Number(int));
      }).join('');
    }
  }]);

  return ComponentEventProcessorBase;
}(Plugin);

exports.default = ComponentEventProcessorBase;